import { render } from "./ReplyQuestion.vue?vue&type=template&id=0d8f6263&scoped=true"
import script from "./ReplyQuestion.vue?vue&type=script&lang=js"
export * from "./ReplyQuestion.vue?vue&type=script&lang=js"

import "./ReplyQuestion.vue?vue&type=style&index=0&id=0d8f6263&scoped=true&lang=css"

import exportComponent from "/Users/giovanialves/Documents/projects/vue/web.vidalonga/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8f6263"]])

export default __exports__